
export const getThemeColor = (theme: any, color?: string) => {
    if (!color) return undefined;
    if (theme?.palette?.[color]) {
        return theme.palette[color].main;
    } else {
        const parts = color.split(".");
        if (parts.length === 2) {
            if (theme?.palette?.[parts[0]]?.[parts[1]])
                return theme.palette[parts[0]][parts[1]];
        }
    }
    return color;
}